import React from "react";

export const LendingIcon: React.FC = () => {
  return (
    <svg
      data-testid="lending-icon"
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_1530_1307)">
        <g clipPath="url(#clip0_1530_1307)">
          <rect x="3" y="2" width="48" height="48.0001" rx="8" fill="#FF9C66" />
          <rect
            x="35.125"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 35.125 2)"
            fill="#631409"
          />
          <rect
            x="38.6758"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 38.6758 2)"
            fill="#631409"
          />
          <rect
            x="31.5742"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 31.5742 2)"
            fill="#631409"
          />
          <rect
            x="24.4766"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 24.4766 2)"
            fill="#631409"
          />
          <rect
            x="20.9258"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 20.9258 2)"
            fill="#631409"
          />
          <rect
            x="17.375"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 17.375 2)"
            fill="#631409"
          />
          <rect
            x="51"
            y="34.127"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 34.127)"
            fill="#631409"
          />
          <rect
            x="51"
            y="37.6758"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 37.6758)"
            fill="#631409"
          />
          <rect
            x="51"
            y="30.5762"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 30.5762)"
            fill="#631409"
          />
          <rect
            x="51"
            y="23.4766"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 23.4766)"
            fill="#631409"
          />
          <rect
            x="51"
            y="19.9258"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 19.9258)"
            fill="#631409"
          />
          <rect
            x="51"
            y="16.375"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 16.375)"
            fill="#631409"
          />
          <g filter="url(#filter1_di_1530_1307)">
            <rect
              x="7"
              y="6"
              width="40"
              height="40.0001"
              rx="6"
              fill="#1A0044"
            />
            <rect
              x="7.24859"
              y="6.24859"
              width="39.5028"
              height="39.5029"
              rx="5.75141"
              stroke="black"
              strokeOpacity="0.2"
              strokeWidth="0.49718"
            />
          </g>
          <g filter="url(#filter2_i_1530_1307)">
            <path
              d="M37.5 36.5H18.3667C17.7133 36.5 17.3866 36.5 17.137 36.3729C16.9175 36.261 16.739 36.0825 16.6272 35.863C16.5 35.6134 16.5 35.2867 16.5 34.6333V15.5M37.5 20.1667L31.16 26.5067C30.929 26.7377 30.8135 26.8532 30.6803 26.8965C30.5631 26.9346 30.4369 26.9346 30.3197 26.8965C30.1866 26.8532 30.0711 26.7377 29.84 26.5067L27.66 24.3266C27.429 24.0956 27.3135 23.9801 27.1803 23.9368C27.0631 23.8988 26.9369 23.8988 26.8197 23.9368C26.6866 23.9801 26.571 24.0956 26.34 24.3266L21.1667 29.5M37.5 20.1667H32.8333M37.5 20.1667V24.8333"
              stroke="white"
              strokeWidth="1.7846"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
        <rect
          x="3.21818"
          y="2.21818"
          width="47.5636"
          height="47.5637"
          rx="7.78182"
          stroke="black"
          strokeOpacity="0.2"
          strokeWidth="0.436364"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_1530_1307"
          x="0.745718"
          y="0.497145"
          width="52.5086"
          height="52.5086"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.751427"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_1530_1307"
          />
          <feOffset dy="0.751427" />
          <feGaussianBlur stdDeviation="0.751427" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1530_1307"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.751427" />
          <feGaussianBlur stdDeviation="1.12714" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_1530_1307"
            result="effect2_dropShadow_1530_1307"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_1530_1307"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_di_1530_1307"
          x="3"
          y="3"
          width="48"
          height="48"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1530_1307"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1530_1307"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.99436" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_1530_1307"
          />
        </filter>
        <filter
          id="filter2_i_1530_1307"
          x="13"
          y="12"
          width="28"
          height="28"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.0605682" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1530_1307"
          />
        </filter>
        <clipPath id="clip0_1530_1307">
          <rect x="3" y="2" width="48" height="48.0001" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
